import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentMultiReturnVerifyEmailData,
  type EnrollmentMultiReturnVerifyEmailSubmitOutput,
} from '../../../../models/enrollment/multi/return-verify-email'

export const getEnrollmentMultiReturnVerifyEmailDataMock: EnrollmentMultiReturnVerifyEmailData = {
  nextStep: 'VERIFY_EMAIL',
  error: null,
  email: 'test@test.com',
}

export const submitEnrollmentMultiReturnVerifyEmailDataMock: EnrollmentMultiReturnVerifyEmailSubmitOutput = {
  nextStep: 'SUBMIT_PHONE',
  error: null,
  email: 'test@test.com',
}

export const mockGetEnrollmentMultiReturnVerifyEmailData = graphql.mutation(
  'getEnrollmentMultiReturnVerifyEmailData',
  () => {
    return HttpResponse.json({ data: { enterApplication: getEnrollmentMultiReturnVerifyEmailDataMock } })
  },
)

export const mockSubmitEnrollmentMultiReturnVerifyEmailData = graphql.mutation(
  'submitEnrollmentMultiReturnVerifyEmailData',
  () => {
    return HttpResponse.json({ data: { enterApplication: submitEnrollmentMultiReturnVerifyEmailDataMock } })
  },
)

export const mockEnrollmentMultiReturnVerifyEmail = [
  mockGetEnrollmentMultiReturnVerifyEmailData,
  mockSubmitEnrollmentMultiReturnVerifyEmailData,
]
